import { SystemStyleObject } from '@chakra-ui/react';
import { SongStatusType } from 'types/song';
import { chakraSongStatusColorEnum } from '../utils';

interface SongStatusInputComponentSxType {
  status: SystemStyleObject;
  coloredDot: SystemStyleObject;
  statusText: SystemStyleObject;
}

export const getSongStatusInputComponentSx = (
  status: SongStatusType
): SongStatusInputComponentSxType => ({
  status: {
    py: 1.5,
    px: 3,
    borderRadius: 4,
    cursor: 'pointer',
    bg: 'M.70',
    _hover: {
      transform: 'scale(1.02)',
    },
  },
  coloredDot: {
    width: 2,
    height: 2,
    minWidth: 2,
    minHeight: 2,
    backgroundColor: chakraSongStatusColorEnum[status].background,
    borderRadius: '50%',
    m: 1,
    mr: 2,
  },
  statusText: {
    fontSize: 'sm',
    fontWeight: 500,
    color: 'M.10',
  },
});
